import React from 'react';
/* HOOKS */
import { useNavigate } from 'react-router-dom';
import useLocale from 'src/hooks/useLocale';
/* SASS */
import './PageNotFound.sass';

const PageNotFound = () => {
  const locale = useLocale();
  const navigate = useNavigate();
  const navToRoot = () => navigate('/');
  return (
    <div className="page-not-found">
      <h2>{locale.pageNotFound.title}</h2>
      <p className="message">{locale.pageNotFound.message}</p>
      <p className="outro">
        {`${locale.pageNotFound.outro1} `}
        <a href="/" onClick={navToRoot}>
          {locale.pageNotFound.outro2}
        </a>
        {` ${locale.pageNotFound.outro3} ${locale.pageNotFound.outro4} ${locale.pageNotFound.outro5}`}
      </p>
    </div>
  );
};

export default React.memo(PageNotFound);
